const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Register = () => import("@/views/pages/Register");

const commonRoutes = {
  mainRoute: "pages/404",
  children: [
    {
      path: "404",
      name: "Page404",
      component: Page404
    },
    {
      path: "500",
      name: "Page500",
      component: Page500
    },
    {
      path: "login",
      name: "Login",
      component: Login
    },
    {
      path: "register",
      name: "Register",
      component: Register
    }
  ]
};

export default commonRoutes;
